export interface NavItem {
  label: string;
  href: string;
  children?: NavItem[];
}

export const navItems: NavItem[] = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Capabilities",
    href: "/capabilities",
    children: [
      { label: "Infrastructure & Network Engineering", href: "/capabilities/infrastructure-network-engineering" },
      { label: "Database & Data Platform Services", href: "/capabilities/database-data-platform" },
      { label: "Application & Platform Engineering", href: "/capabilities/application-platform-engineering" },
      { label: "Microsoft Solutions", href: "/capabilities/microsoft-solutions" },
      { label: "Web & Digital Solutions", href: "/capabilities/web-digital-solutions" },
      { label: "Mobile Application Development", href: "/capabilities/mobile-application-development" },
      { label: "Cloud Services", href: "/capabilities/cloud-services" },
      { label: "AI & Intelligent Engineering", href: "/capabilities/ai-intelligent-engineering" },
    ],
  },
  {
    label: "Experience",
    href: "/experience",
    children: [
      { label: "Experience Overview", href: "/experience" },
      { label: "USA Government Experience", href: "/experience/usa-government" },
      { label: "International Government Experience", href: "/experience/international" },
      { label: "Commercial Experience", href: "/experience/commercial" },
    ],
  },
  {
    label: "Markets",
    href: "/markets",
  },
  {
    label: "About",
    href: "/about",
    children: [
      { label: "Company", href: "/about" },
      { label: "Careers", href: "/about/careers" },
    ],
  },
  {
    label: "Resources",
    href: "/resources",
    children: [
      { label: "Capability Statement", href: "/resources/capability-statement" },
      { label: "Contracting Information", href: "/resources/contracting-information" },
      { label: "Insights", href: "/resources/insights" },
    ],
  },
  {
    label: "Employees",
    href: "/contact",
    children: [
      { label: "TimeSheet Login", href: "https://us-timesheet-management.vercel.app/login" },
      { label: "Paychex", href: "https://www.paychex.com/" },
    ],
  },
  {
    label: "Contact",
    href: "/contact",
  },
];